/*
 * Copyright (c) 2022 Puratos. All rights reserved.
 */

import React from 'react';
import PropTypes from 'prop-types';
import {RowCell} from "../../atoms/layout/RowCell";
import {HTMLParagraph} from "../../atoms/layout/HTMLParagraph";
import {Button} from "../../atoms/bootstrap/Button";
import {navigate} from "../../../utils/redux";

export const rowTextCellSizes = {xxs: 5, xs: 5, sm: 8};
export const rowBtnCellSizes = {xxs: 7, xs: 7, sm: 4};

export function TextColumn(props) {
    const {text, btnLabel, btnAction, textSizes, btnSizes, fontSans, textCenter, className} = props;

    const textSize = (btnLabel && btnAction) || rowTextCellSizes !== textSizes ? textSizes : {xxs: 12, xs: 12, sm: 12};

    return (
        <React.Fragment>
            {text && <RowCell sizes={{...textSize}}
                              className={`table-group-cell--text ${className} ${textCenter ? 'p-flex-justify-content-center' : ''}`}>
                <HTMLParagraph className={`text-muted ${fontSans ? 'p-sans' : 'p-serif-nr'} `} text={text}/>
            </RowCell>}

            {btnLabel && btnAction && <RowCell sizes={{...btnSizes}} className={`table-group-cell--btn ${className}`}>
                <Button color={Button.colors.SECONDARY} onClick={() => navigate(btnAction)}>
                    {btnLabel}
                </Button>
            </RowCell>}
        </React.Fragment>
    )
}

TextColumn.propTypes = {
    text: PropTypes.string,
    btnLabel: PropTypes.string,
    btnAction: PropTypes.string,
};

TextColumn.defaultProps = {
    className: "",
    textSizes: rowTextCellSizes,
    btnSizes: rowBtnCellSizes,
    fontSans: false,
    textCenter: false,
};

export default TextColumn;
